import React from 'react';
import { withRouter } from 'react-router-dom';

import { ReactComponent as PlayAlt } from 'assets/icons/play@2x.svg';
import { ReactComponent as Lock } from 'assets/icons/lock.svg';

import styles from './Masterclass.module.scss';

import { shouldOpenPurchaseModal } from 'utils/inAppPurchaseUtils';
import { useModals } from 'context/modal/useModals';

const Masterclass = ({ search, data, history, showModal, user }) => {
    const modals = useModals();
    const navigate = (to = '/home', episode) => {
        // eslint-disable-next-line no-unused-expressions
        episode?.locked
            ? user && user.user_tier !== 'premium_level_1'
                ? shouldOpenPurchaseModal(
                      episode,
                      modals,
                      () => {
                          showModal('masterclasses');
                      },
                      to,
                      search
                  )
                : null
            : history.push(to);
    };

    return (
        <div
            className={styles.masterclass}
            onClick={() => navigate(`/masterclass/chapter/${data.id}`, data)}
        >
            <div className={styles.container}>
                {user && user.user_tier !== 'premium_level_1' && data.locked ? (
                    <Lock />
                ) : (
                    <PlayAlt />
                )}
                <div
                    className={styles.image_container}
                    style={{
                        backgroundImage: `url(${(data.hero_image &&
                            data.hero_image.url) ||
                            (data.thumbnail && data.thumbnail.url)})`,
                    }}
                >
                    {user &&
                        user.user_tier !== 'premium_level_1' &&
                        data.locked && <div className={styles.mask}></div>}
                    {(!data.locked ||
                        (user &&
                            user.user_tier === 'premium_level_1' &&
                            data.locked)) && (
                        <div className={styles.mask_unlocked}></div>
                    )}
                </div>
                <div className={styles.inner}>
                    {/* <div className={styles.tags}>
						{data.tags && data.tags.map(tag => {
							return <span key={tag}>{tag}</span>;
						})}
					</div> */}
                    <div
                        className={styles.title}
                        style={{
                            opacity:
                                user &&
                                user.user_tier !== 'premium_level_1' &&
                                data.locked
                                    ? '0.5'
                                    : '1',
                        }}
                    >
                        {user &&
                            user.user_tier === 'premium_level_1' &&
                            data.locked && (
                                <div className={styles.coming_soon}>
                                    COMING SOON
                                </div>
                            )}
                        <div>{data.title}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(Masterclass);
